<template>
    <app-layout title="Te bezoeken">
        <template #header>
            <page-title title="Te bezoeken" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm" layout="horizontal" class="w-full">
                <Input
                    label="Gepland van"
                    name="planned_from"
                    type="date"
                    placeholder="dd-mm-jjjj"
                    v-model="form.planned_from"
                    :error="form.errors.planned_from"
                    layout="vertical"
                />
                <Input
                    label="Gepland tot en met"
                    name="planned_until"
                    type="date"
                    placeholder="dd-mm-jjjj"
                    v-model="form.planned_until"
                    :error="form.errors.planned_until"
                    layout="vertical"
                />
                <Select
                    label="ADI"
                    name="executor"
                    :emptyOption="true"
                    :options="allExecutors"
                    v-model="form.executor"
                    :error="form.errors.executor"
                    layout="vertical"
                    v-if="this.$page.props.user.permissions.includes('requests.view.all')"
                />

                <Button text="Zoeken" buttonType="submit" buttonClass="filter" :loading="form.processing" />
            </Form>

            <ModalPlanVisit
                visible="hidden"
                :request="requestToReplan"
                :executorOptions="executorOptions"
                :replanVisit="replanVisit"
                @visitReplanned="visitReplanned"
                v-model:visitToReplan="visitToReplan"
                ref="modalPlanVisit"
            />

            <Table :id="'overview-requests-visits'" :values="requests" class="mt-4">
                <thead>
                    <tr>
                        <Th id="planned_at">Gepland op</Th>
                        <Th id="executor">ADI</Th>
                        <Th id="reference">Referentie</Th>
                        <Th id="address">Inspectie adres</Th>
                        <Th id="postal_code">Postcode</Th>
                        <Th id="place">Gemeente</Th>
                        <Th id="key">Sleutel</Th>
                        <Th :sort="false" class="min-w-[72px]"></Th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(request, key) in state.sortedValues['overview-requests-visits']"
                        :key="key"
                        :class="{ 'bg-red-200': request.planned_at && moment(request.planned_at + ' 23:59:59') < moment(now),
                    }"
                    >
                        <Td>
                            {{ (request.planned_at) ? moment(request.planned_at).format('DD-MM-YYYY') : '' }} {{ (request.start_time) ? moment(request.start_time, 'HH:mm:ss').format('HH:mm') : '' }}
                        </Td>
                        <Td>
                            {{ request.name }}
                        </Td>
                        <Td>
                            <Link :href="route('requests.detail',  {'id': request.id})">
                                {{ request.reference }}
                            </Link>
                        </Td>
                        <Td>{{ request.address }}</Td>
                        <Td>{{ request.postal_code }}</Td>
                        <Td>{{ request.place }}</Td>
                        <Td class="text-center">
                            <i class="fas fa-check text-blue-dark-500" v-if="request.key"></i>
                            <div v-if="request.key">
                                {{ request.key_address }}
                            </div>
                        </Td>
                        <Td>
                            <Button
                                htmlType="a"
                                buttonClass="show"
                                size="small"
                                title="Details"
                                :href="route('requests.detail',  {'id': request.id})"
                            />
                            <Button
                                title="Herinplannen"
                                buttonClass="redo"
                                size="small"
                                @click="replanRequestVisit(request)"
                                v-if="request.planned_at && this.$page.props.user.permissions.includes('requests.planvisit')"
                            />
                        </Td>
                    </tr>
                </tbody>
            </Table>

        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'
import Select from '@/Components/Select.vue'
import ModalPlanVisit from "@/Components/Requests/ModalPlanVisit.vue";

import store from '@/store'
import moment from "moment"
import {Link, useForm} from '@inertiajs/inertia-vue3';
import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Input,
        Form,
        Select,
        Link,
        ModalPlanVisit,
    },
    props: [
        'requests',
        'requestTypes',
        'executors',
    ],
    setup (props){
        let allExecutors = {}//All executors, also blocked ones
        let executorOptions = {}//All executors, except blocked ones
        const urlQueryString = window.location.search
        const urlParams = new URLSearchParams(urlQueryString);
        let replanVisit = ref(false)
        let requestToReplan = ref(null)
        let visitToReplan = ref(null)
        const now = new Date();

        props.executors.forEach(function(executor) {
            allExecutors[executor.username] = executor.name

            if (executor.status !== 'blocked')
            {
                executorOptions[executor.username] = executor.name
            }

            if (executor.status === 'pending')
            {
                allExecutors[executor.username] += ' (Nog niet in dienst)'
                executorOptions[executor.username] += ' (Nog niet in dienst)'
            }
        })

        const form = useForm({
            planned_from: urlParams.get('planned_from') ?? null,
            planned_until: urlParams.get('planned_until') ?? null,
            executor: urlParams.get('executor') ?? null,
        })

        function postForm()
        {
            Inertia.get(
                window.location.href,
                {
                    planned_from: form.planned_from,
                    planned_until: form.planned_until,
                    executor: form.executor,
                    column: store.state.currentCol[store.state.currentTableId],
                    direction: store.state.currentDir[store.state.currentTableId],
                    page: 1,
                },
                {
                    // replace: true,
                    preserveState: true,
                    'only': ['requests'],
                    onSuccess: () => {
                        store.changeAllValues({values: props.requests, id: store.state.currentTableId})
                    }
                }
            )
        }

        function replanRequestVisit(request)
        {
            let visit = {}
            visit.id = request.visit_id
            visit.planned_at = request.planned_at
            visit.start_time = request.start_time
            visit.end_time = request.end_time
            visit.executor = request.executor
            visit.key = request.key
            visit.key_address = request.key_address
            visit.info = request.visit_info

            requestToReplan.value = request
            visitToReplan.value = visit
            replanVisit.value = true
        }

        function visitReplanned()
        {
            replanVisit.value = false
        }

        return {
            state: store.state,
            ...store,
            allExecutors,
            executorOptions,
            form,
            postForm,
            replanVisit,
            requestToReplan,
            visitToReplan,
            replanRequestVisit,
            visitReplanned,
            now,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
